// import textStyles from './text-styles.theme'

export default {
  variants: {
    // extraSmall: textStyles.extraSmallTitle,
  }
}
